import { frontendURL } from '../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/properties'),
      name: 'properties_wrapper',
      meta: {
        permissions: ['administrator'],
      },
      component: () => import('./Wrapper.vue'),
      children: [
        {
          path: '',
          name: 'properties_index',
          meta: {
            permissions: ['administrator'],
          },
          component: () => import('./Index.vue'),
        },
      ],
    },
  ],
};
